
const digest = '0c833d4c9788ed2a111baf0c4de6039d46b36e3db2ef2b18976947bd3992fa75';
const classes = {"wrapper":"_wrapper_wi3ie_1","list":"_list_wi3ie_4","item":"_item_wi3ie_9"};
const css = `._wrapper_wi3ie_1 {
  font-family: Rubik, "sans-serif";
}
._wrapper_wi3ie_1 ._list_wi3ie_4 {
  gap: 5px;
  display: flex;
  flex-direction: column;
}
._wrapper_wi3ie_1 ._list_wi3ie_4 ._item_wi3ie_9 {
  display: flex;
  flex-direction: row;
  justify-content: space-between;
}`;

(function() {
  if (typeof document !== "undefined" && !document.getElementById(digest)) {
    var ele = document.createElement('style');
    ele.id = digest;
    ele.textContent = css;
    document.head.appendChild(ele);
  }
})();

export default classes;
export { css, digest, classes };
  